module.exports = __webpack_public_path__ + "img/active-tick.fa6680b6.svg";